import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Popover, Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { loginProModalOpen } from 'actions/Login/login.action';
import { FormattedMessage } from 'react-intl';
import './customPopover.css';

const FreeProPopUp = ({ isVisible, children, showPro = null }) => {
  const dispatch = useDispatch();
  const [isOpen, setOpen] = useState(true);

  function changeOpen() {
    setOpen(!isOpen);
  }

  useEffect(() => {
    window.addEventListener('scroll', changeOpen, true);
    return () => {
      window.removeEventListener('scroll', changeOpen, true);
    };
  }, []);

  const getContent = (
    <div className="aboveLoginRegisterForm">
      <CloseOutlined className="closeFreePro" onClick={() => setOpen(false)} />
      <FormattedMessage
        id="New users can try Pro on web and Navigation on the iPhone and Android app free for 14 days"
        defaultMessage="New users can try Pro on web and Navigation on the iPhone and Android app free for 14 days"
      />
      <br />
      <FormattedMessage
        id="See full list of features"
        defaultMessage="See full list of features"
      />
      &nbsp;
      {showPro ? (
        <Button
          style={{
            fontSize: '12px',
            lineHeight: '18px',
            height: '18px',
            padding: 0,
          }}
          onClick={showPro}
          type="link"
        >
          <span>
            <FormattedMessage id="here" defaultMessage="here" />
          </span>
        </Button>
      ) : (
        <Link onClick={() => dispatch(loginProModalOpen(true))} to="/pro">
          <FormattedMessage id="here" defaultMessage="here" />
        </Link>
      )}
      ;
    </div>
  );

  return (
    <Popover
      content={getContent}
      trigger="click"
      visible={isOpen && isVisible}
      placement="top"
      overlayStyle={{
        zIndex: 1000,
        top: '105px !important',
        maxWidth: '355px',
        fontSize: '12px',
        textAlign: 'center',
      }}
    >
      {children}
    </Popover>
  );
};

FreeProPopUp.displayName = 'FreeProPopUp';
FreeProPopUp.propTypes = {
  isVisible: PropTypes.bool,
  showPro: PropTypes.func,
};

export default FreeProPopUp;
